import { ComponentType } from 'react';
import styled from 'styled-components';
import { Button } from 'ui/button';
import { EmptyState } from 'ui/emptyState';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const EmptyStateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${pxToRem(408)};
`;

const Subtitle = styled.div`
  color: ${colors.textSecondary};
`;

const RefreshSubtitle = styled.div`
  align-items: center;
  gap: ${spacing.plusHalf};
  display: flex;
  flex-direction: column;
  width: ${pxToRem(500)};
`;

type AlternativeStateProps = {
  Illustration: ComponentType<React.PropsWithChildren<unknown>>;
  title: string;
  subtitle: string;
  showRefreshBtn?: boolean;
};

export const AlternativeState = ({
  Illustration,
  title,
  subtitle,
  showRefreshBtn,
}: AlternativeStateProps) => {
  const formattedSubtitle = showRefreshBtn ? (
    <RefreshSubtitle>
      <span>{subtitle}</span>
      <Button>Refresh page</Button>
    </RefreshSubtitle>
  ) : (
    subtitle
  );

  return (
    <EmptyStateWrapper>
      <EmptyState
        Illustration={Illustration}
        title={title}
        subtitle={<Subtitle>{formattedSubtitle}</Subtitle>}
      />
    </EmptyStateWrapper>
  );
};
